import type {TeamInsightsActionItem, TeamInsightsActionItemCategory} from "@/shared/timr";

export const ACTION_ITEM_CATEGORIES: TeamInsightsActionItemCategory[] = [
	"VACATION_AND_ABSENCE",
	"WORKTIME_VALIDATIONS",
	"TIME_ACCOUNT"
];

/** A single recommendation flattened together with the employee it belongs to (the unit the UI renders/filters/sorts). */
export interface Recommendation {
	resultId: number;
	userId: number;
	userName: string;
	item: TeamInsightsActionItem;
}
